'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './guest-list.routes';

export class GuestListComponent {
  constructor(GuestService, dialogs, Auth, AttendanceService, DTOptionsBuilder) {
    'ngInject';
    this.dialogs = dialogs;
    this.GuestService = GuestService;

    this.dtOptions = DTOptionsBuilder
      .newOptions()
      .withBootstrap()
      .withOption('order', [0, 'desc'])
      .withOption('responsive', true);

    let userId = Auth.getCurrentUserSync()._id;

    AttendanceService.query(data => {
      this.data = data.filter(attendance => attendance.type === 'guest' && attendance.member && attendance.member == userId);
    })
    
  }
/*
  delete(guest) {
    var that = this;

    var guestText = "<br/><br/><b>" + guest.name + "</b>";

    var dlg = this.dialogs.confirm("Delete Guest?", "Do you really want to delete the Guest?" + guestText);
    dlg.result.then(() => {
      // OK delete it
      that.GuestService.delete({id: guest._id},
        () => {
          that.data = that.data.filter(function( obj ) {
            return obj._id !== guest._id;
          });
        },
        err => {
          alert("Could not delete guest");
        });
    }, () => {
      // Cancel
    });
  }*/
}

export default angular.module('conduuApp.guestList', [uiRouter])
  .config(routes)
  .component('guestList', {
    template: require('./guest-list.html'),
    controller: GuestListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/guest/list/guest-list.component.js